const linkRightMenu: { name: string, aliases: Array<string>, link: string, places: Array<string> }[] = [
  {
    name: 'Заявки',
    places: [
      'profile',
      'orders',
      'order',
      'documents',
      // 'companies',
      'delivery-edit',
      'connect-company'
    ],
    aliases: [
      'orders',
      'order'
    ],
    link: '/'
  },
  {
    name: 'Мой профиль',
    places: [
      'profile',
      'orders',
      'order',
      'documents',
      // 'companies',
      'delivery-edit',
      'connect-company'
    ],
    aliases: [
      'profile'
    ],
    link: '/profile'
  },
  {
    name: 'Мои документы',
    places: [
      'profile',
      'orders',
      'order',
      // 'companies',
      'documents',
      'delivery-edit',
      'connect-company'
    ],
    aliases: [
      'documents',
      'document'
    ],
    link: '/documents'
  },
  // {
  //   name: 'Мои компании',
  //   places: [
  //     'profile',
  //     'orders',
  //     // 'companies',
  //     'order',
  //     'documents',
  //     'delivery-edit',
  //     'connect-company'
  //   ],
  //   aliases: [
  //     'companies',
  //     'company'
  //   ],
  //   link: '/companies'
  // },
  {
    name: 'Связаться с компанией',
    places: [
      'profile',
      'orders',
      'order',
      'documents',
      'connect-company'
    ],
    aliases: [
      'connect-company'
    ],
    link: '/connect-company'
  }
]

export { linkRightMenu }